import React from 'react'

const Footer = () => {
  return (
    <div
      className="footer"
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '200px',
        fontSize: '35px',
        color: 'rgba(0,0,0,0.5)',
        textTransform: 'uppercase',
      }}
    >
      <i
        className="fa fa-globe"
        aria-hidden="true"
        style={{ marginTop: '10px', paddingRight: '10px' }}
      />https://reddirtwebdesign.com
      <i
        className="fa fa-facebook-official"
        aria-hidden="true"
        style={{
          marginLeft: '100px',
          paddingRight: '10px',
          marginTop: '10px',
        }}
      />https://facebook.com/RedDirtWGD
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js